/*
 * @Descripttion: 
 * @version: 
 * @Author: zhouxh
 * @Date: 2023-05-24 08:37:19
 */
import Mock from "mockjs"

// 所有的服务端接口在接收到请求后，均响应以下JSON格式

Mock.mock("/index.php/jobs-data","get",{
    code: 0,//错误码
    msg: "",//错误消息
    //data为具体的消息内容，如果code不为0，则必为null
    data: [
        {   
            id:1,
            jobTitle: '测试助理工程师',
            jobType: '研发技术',
            workplace: '上海市或苏州',
            county: '浦东新区',
            jobCategory: '全职',
            releaseTime: '2023-07-22',
            jobDescription: [
                "使用常见的测试工具进行软件测试；",
                "在指导下编写并执行测试用例，进行功能测试、功能安全测试、网络测试、通讯测试、诊断测试、刷写测试和部分自动化测试；",
                "独立出具测试报告；",
                "参与测试计划的制定和测试环境的搭建；",
                "发现产品中的Bug，定位到具体的开发人员，协助开发人员进行解决问题；",
                "使用禅道工具进行故障管理；",
            ],
            jobQualification: [
                 `大学本科及以上学历`,
                 `电气、电子，测试与技术等相关专业`,
                 `1年以上车载测试类工作经验、熟悉车载测试相关基础知识或相关领域的实习经验、了解测试基本的相关概念，方法及流程。`,

            ],
            qualificationRemark: "",

            socialBenefits: ["五险一金", "餐饮补贴", "员工宿舍", "周末双休","法定节假日","员工体检","生日会","年终奖金","年终涨薪","团建","节日福利","上海人才落户（高新技术企业政府给的政策）"]

        },


        
        {   
            id:2,
            jobTitle: '软件助理工程师',
            jobType: '研发技术',
            workplace: '上海市或苏州',
            county: '浦东新区',
            jobCategory: '全职',
            releaseTime: '2023-07-22',
            jobDescription: [
                "协助编制和维护汽车电子软件相关的技术文档，确保文档内容的准确性和完整性；",
                "在大框架和方法指导下，可以独立执行汽车电子软件的代码编写工作,按照设计要求实现软件功能；",
                "为团队成员或客户提供技术支持，解答关于汽车电子软件的问题；",
                "协助配合测试工程师完成测试工作计划；",
                "能够完成程序单元测试、集成测试、系统测试和合格性测试，协助一起创建测试模型/代码，及时发现模型/代码问题；",
                "能够独立进行部分CAN/LIN网络的配置、测试和故障排查，在指导下完成复杂的配置和测试；",
                "在大框架和方法指导下，能够独立执行软件通讯、软件诊断、软件BOOT、网络管理单一模块的开发；",
                "能够详细记录测试结果，并参与技术讨论",
                "完成领导临时安排的其他工作。"
            ],
            jobQualification: [
                 "大学本科及以上学历；",
                 "电子电气、电子信息、计算机等相关专业；",
                 "汽车电子软件类1年以上工作经验。",
            ],
            qualificationRemark: "",

            socialBenefits: ["五险一金", "餐饮补贴", "员工宿舍", "周末双休","法定节假日","员工体检","生日会","年终奖金","年终涨薪","团建","节日福利","上海人才落户（高新技术企业政府给的政策）"]

        },


        
        {   
            id:3,
            jobTitle: '硬件助理工程师',
            jobType: '研发技术',
            workplace: '上海市或苏州',
            county: '浦东新区',
            jobCategory: '全职',
            releaseTime: '2023-07-22',
            jobDescription: [
                "独立进行简单的原理图绘制，独立完成2层及以上PCB；",
                "在指导下修改复杂项目原理图和PCB；",
                "负责编制产品元器件BOM表；",
                "独立使用万用表、示波器、电烙铁测试及修改PCB板；",
                "在测试计划的基础上，负责测试负载和板端信号，并整理数据及出具测试报告；",
                "在指导下进行工装开发工作；",
                "完成领导安排的其他工作或临时性任务。",
            ],
            jobQualification: [
                 "大学本科及以上学历；",
                 "电子、电气、模似电路、机械相关专业；",
                 "1年以上汽车控制器电路设计开发工作经验、熟悉电路基础知识、掌握原理图和PCB设计工具。",
            ],
            qualificationRemark: "",

            socialBenefits: ["五险一金", "餐饮补贴", "员工宿舍", "周末双休","法定节假日","员工体检","生日会","年终奖金","年终涨薪","团建","节日福利","上海人才落户（高新技术企业政府给的政策）"]

        },



    ]
})



